export default __webpack_public_path__ + "static/media/checked.2b3af844.svg";